/**
 * Muzli — design inspiration new-tab / hub
 *
 * Declares two web-accessible-resource entries: `index.html` and `slack.html` matched to
 * every origin, plus a catch-all glob matched to every http(s) origin — all with no
 * `use_dynamic_url`. So the whole package, including its `images/` tree, is fetchable
 * from any page at a fixed URL. The `images/brandnew_bg.png` background loads through
 * `probeImage` with no CORS grant, making a load conclusive.
 *
 * Manifest verified against version 33.1.2.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'glcipcfhmopcgidicgdociohdoicpdfc';

export const muzli: ExtensionDefinition = {
  id: ID,
  name: 'Muzli - Design inspiration hub',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 400_000,
  notes:
    'A catch-all WAR glob plus named HTML entries on every origin with no dynamic URL. ' +
    'The brandnew_bg.png image loads without a CORS grant and is conclusive.',
  signals: [
    {
      id: 'war-brandnew-bg',
      kind: 'web-accessible-resource',
      description:
        'Load images/brandnew_bg.png via <img> — a packaged background image reachable ' +
        'via the catch-all glob, readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'images/brandnew_bg.png'),
    },
    {
      id: 'war-slack-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch slack.html — a named static entry point exposed to every origin.',
      weight: 0.5,
      run: () => probeFetch(ID, 'slack.html'),
    },
    {
      id: 'war-icon-chat',
      kind: 'web-accessible-resource',
      description:
        'Load images/dark/icon_chat.png via <img> — a second image path corroborating ' +
        'the identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'images/dark/icon_chat.png'),
    },
  ],
};
